import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText
} from '@material-ui/core';
import Button from "@components/common/button/Button";
import * as React from 'react';

import TranslateNew from '@translate/TranslateNew';
const tn :TranslateNew = TranslateNew.getInstance();

interface IProps {
  isOpen: boolean;
  title: string;
  paragraphs: string[];
  confirmLabel: string;
  onClose: () => void;
  onSubmit: () => void;
}

// For settings with consequences the user has to accept before they are turned on.
const ConfirmSettingDialog = (props: IProps) => (
  <Dialog
    open={props.isOpen}
    onClose={props.onClose}
  >
    <DialogTitle>
      {props.title}
    </DialogTitle>
    <DialogContent>
      {props.paragraphs.map((paragraph) => (
        <DialogContentText key={paragraph}>
          {paragraph}
        </DialogContentText>
      ))}
    </DialogContent>
    <DialogActions style={{justifyContent: "center", flexDirection: "column", gap: "10px", margin: "8px"}}>
      <Button style={{height: "35px"}} variant='contained' color='secondary' onClick={props.onSubmit}>
        {props.confirmLabel}
      </Button>
      <Button variant='outlined' onClick={props.onClose}>{tn.lang.cancel}</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmSettingDialog;



// WEBPACK FOOTER //
// ./src/components/settings/confirm-setting.component.tsx